import React, { Component } from 'react'

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'

import history from '../../../../history'
import { Input, Popconfirm, Button, Form, Modal, Icon, Upload, message, Spin } from 'antd'

import { actions as leadAttachmentActions } from '../../../../redux/modules/leadFunctions/leadAttachmentActions'

import * as authSelectors from '../../../../selectors/auth'
import * as leadAttachmentsSelectors from '../../../../selectors/lead/attachments'

const FormItem = Form.Item
const { TextArea } = Input

const propTypes = {
  action: PropTypes.string.isRequired,
  handleCancel: PropTypes.func.isRequired,
  leadId: PropTypes.any.isRequired,
  attachmentIdParam: PropTypes.any,
  contentData: PropTypes.object,
  user: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,

  // from leadAttachmentActions
  createLeadAttachment: PropTypes.func.isRequired,
  updateLeadAttachment: PropTypes.func.isRequired
}

class AddEditFormModal extends Component {
  state = {
    fileList: []
  }
  handleCreate = () => {
    const { leadId, attachmentIdParam, user, action } = this.props
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      const { fileList } = this.state
      const formData = new FormData()
      fileList.forEach(file => {
        formData.append('file', file)
      })
      formData.append('leadId', leadId)
      formData.append('type', 'lead')
      formData.append('attachmentId', attachmentIdParam)
      formData.append('content', values)
      formData.append('description', values.description)
      formData.append('userId', user.userId)

      if (action === 'add') {
        formData.append('filename', fileList[0].name)

        this.props.createLeadAttachment({
          leadId: leadId,
          content: values,
          file: formData,
          filename: fileList[0].name,
          userId: user.userId
        })
        message.warning('Uploading file...')
      } else {
        this.props.updateLeadAttachment({
          leadId: leadId,
          description: values.description,
          attachmentId: attachmentIdParam,
          userId: user.userId
        })
        message.success('Changes saved.')
      }

      form.resetFields()
      history.push(`/lead/${leadId}/attachments`)
      this.setState({ content: null, currentId: 0, modalVisible: false, fileList: [] })
    })
  }

  confirmDelete = event => {
    const { leadId, attachmentIdParam } = this.props
    const form = this.props.form

    this.props.deleteLeadAttachment({
      leadId: leadId,
      attachmentId: attachmentIdParam
    })

    form.resetFields()
    message.success('Record deleted.')
    history.push(`/lead/${leadId}/attachments`)
  }

  render() {
    const { contentData, handleCancel, loading } = this.props
    const { getFieldDecorator } = this.props.form
    const uploadProps = {
      onRemove: file => {
        this.setState(({ fileList }) => {
          const index = fileList.indexOf(file)
          const newFileList = fileList.slice()
          newFileList.splice(index, 1)
          return {
            fileList: newFileList
          }
        })
      },
      beforeUpload: file => {
        this.setState(({ fileList }) => ({
          fileList: [...fileList, file]
        }))
        return false
      },
      fileList: this.state.fileList
    }
    return (
      <Modal
        visible={true}
        title="Attachments"
        okText={contentData ? 'Save Changes' : 'Create'}
        onCancel={handleCancel}
        onOk={this.handleCreate}
        maskClosable={false}
      >
        <Spin spinning={loading}>
          <Form layout="vertical">
            {!contentData && (
              <FormItem label="Files">
                {getFieldDecorator('files', {
                  rules: [
                    {
                      required: !contentData ? false : true,
                      message: 'FFFF cannot be blank.'
                    }
                  ],
                  initialValue: contentData ? contentData.description : ''
                })(
                  <Upload {...uploadProps}>
                    <Button>
                      <Icon type="upload" /> Upload
                    </Button>
                  </Upload>
                )}
              </FormItem>
            )}
            <FormItem label="Description">
              {getFieldDecorator('description', {
                rules: [
                  {
                    required: true,
                    message: 'Note description cannot be blank.'
                  }
                ],
                initialValue: contentData ? contentData.description : ''
              })(
                <TextArea
                  placeholder="Describe the attachment..."
                  rows={4}
                  initialvalue={contentData ? contentData.description : ''}
                />
              )}
            </FormItem>
            <Popconfirm
              title="Are you sure you want to delete this record?"
              onConfirm={this.confirmDelete}
              onCancel={this.cancelDelete}
              okText="Yes"
              cancelText="No"
            >
              {contentData && <Button type="danger" icon="delete" />}
            </Popconfirm>
          </Form>
        </Spin>
      </Modal>
    )
  }
}

const mapStateToProps = (state, props) => ({
  user: authSelectors.getUser(state, props),
  loading: leadAttachmentsSelectors.getLeadAttachmentsLoading(state, props)
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, leadAttachmentActions), dispatch)
})

AddEditFormModal.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(AddEditFormModal))
)



// WEBPACK FOOTER //
// ./src/pages/lead/components/attachments/AddEditFormModal.component.js